// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"372":"af1c87b9","507":"af1c87b9"}[chunkId] + ".css";
};